import axios, { AxiosError } from 'axios'
import {
  HereMapApi,
  HereMapEndpoint,
  hereMapsCountryCodes,
  HouseNumber,
} from '../utils/constants'
import environmentVariables from '../environment'
import { logger } from '../utils/logger'
import {
  AutoCompleteAddress,
  AutoCompleteResponse,
  GeocodeRequest,
  GeocodeResponse,
} from '../types/hereMaps'
import { CountryCode } from '../types/locale'

const geocodeAxiosInstance = axios.create({
  baseURL: environmentVariables.HERE_MAP_GEOCODE_API,
  headers: {
    'Content-Type': 'application/json',
  },
})

const autoCompleteInstance = axios.create({
  baseURL: HereMapApi.AutoSuggest,
  headers: {
    'Content-Type': 'application/json',
  },
})

export async function getGeocodeAddress(
  geocodeRequest: GeocodeRequest,
): Promise<GeocodeResponse> {
  const params = {
    q: geocodeRequest.q,
    apiKey: environmentVariables.HERE_MAP_API_KEY,
  }
  return geocodeAxiosInstance
    .get<GeocodeResponse>(HereMapEndpoint.Geocode, { params })
    .then((response) => {
      return response.data
    })
    .catch((error: AxiosError) => {
      logger('log', 'getEnrichedZipCode error: ', error)
      throw error
    })
}

export async function getAutoSuggestedAddress(
  countryCode: CountryCode,
  addressRequest: string,
): Promise<AutoCompleteAddress[]> {
  const params = {
    q: addressRequest,
    in: hereMapsCountryCodes[countryCode],
    apiKey: environmentVariables.HERE_MAP_API_KEY,
  }
  return autoCompleteInstance
    .get<AutoCompleteResponse>(HereMapEndpoint.AutoComplete, { params })
    .then((response) => {
      const autoSuggestedResponse = response.data
      return (
        autoSuggestedResponse?.items.filter(
          (data) => data.resultType === HouseNumber,
        ) ?? []
      )
    })
    .catch((error: AxiosError) => {
      logger('log', 'getAutoSuggestedAddress error: ', error)
      throw error
    })
}
